import type { FaireProductEntity } from "../../entity_types/product";

export const p_5xns4q656w: FaireProductEntity = {
  token: "p_5xns4q656w",
  type: "product",
  name: "The Cr\u00e8me Shop Klean Beauty\u2122 Vitamin C Face Sheet Mask",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/44c090d51f0c96793610c837d598460a814a98f9dfef1db4101bedfe3e2a932d.png",
  priceDollars: 0.55,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
